import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { AuthService, GlobalMessageService, WindowRef, OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export  class ClaimsService {
    
    constructor(
        private httpClient: HttpClient,
        private occService: OccEndpointsService
      ) {
      }
      createClaim(requestBody: any,userData: any): Observable<any> {
          return  this.httpClient.post<any>(this.occService.buildUrl(`/orgUsers/${userData.uid}/createB2BUserClaimRequest?fields=FULL`), requestBody)
      }  
}

